import Validator from '../validator';

function isValidUrl(value: string) {
  let url;

  try {
    url = new URL(value);
  } catch {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:' || url.protocol === 'ftp:';
}

Validator.register('url', (value: string) => {
  let message: string | null = null;
  if (value && !isValidUrl(value)) {
    message = 'Enter a valid url';
  }
  return message;
});
